import { FileText } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";

interface Answer {
  index: number;
  selectedOption: string;
  questionText: string;
  answerText: string;
}

interface Position {
  id: number;
  name: string;
  description: string;
}

interface AnswersDialogProps {
  answers: Answer[];
  selectedPositionInfo: Position | undefined;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AnswersDialog({
  answers,
  selectedPositionInfo,
  open,
  onOpenChange,
}: AnswersDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger
        nativeButton={true}
        render={
          <Button
            size="lg"
            variant="outline"
            className="px-2 border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white"
          >
            <FileText className="w-4 h-4" />
            查看答题记录
          </Button>
        }
      />
      <DialogContent className="max-w-2xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="flex items-center space-x-2">
            <FileText className="w-5 h-5" />
            <span>答题记录</span>
          </DialogTitle>
          <DialogDescription>
            你选择的位置：
            {selectedPositionInfo?.name} - {selectedPositionInfo?.description}
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[60vh] pr-4">
          <div className="space-y-4">
            {answers.map((answer, index) => (
              <Card key={answer.index} className="border-gray-700">
                <CardHeader className="pb-3">
                  <CardTitle className="text-sm font-medium text-gray-300">
                    问题 {index + 1}
                  </CardTitle>
                  <CardDescription className="text-white">{answer.questionText}</CardDescription>
                </CardHeader>
                <CardContent className="pt-0">
                  <div className="flex items-start space-x-2">
                    <Badge variant="secondary" className="mt-0.5">
                      {answer.selectedOption}
                    </Badge>
                    <span className="text-gray-300 text-sm">{answer.answerText}</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
